<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// I18N
// ================================
// Copy portée verbatim de v5 `lang/components-header.lang.js`
// (clé `component.header_past_due_payment`).
const { t } = useI18n({
    messages: {
        fr: {
            title: "Attention vous avez une facture en attente",
            subtitle:
                "Vous avez un retard de paiement sur votre abonnement, veuillez régulariser votre situation",
            button: "Voir mes abonnements",
        },
        en: {
            title: "You have an unpaid invoice",
            subtitle:
                "Your subscription has an overdue payment, please settle your situation",
            button: "View my subscriptions",
        },
    },
})
</script>

<template>
    <div
        class="banner-past-due flex w-full flex-col items-stretch gap-2 bg-red-100 px-5 py-3 text-red-700 sm:flex-row sm:items-center sm:justify-between"
        role="alert"
        aria-live="polite"
    >
        <div class="flex flex-col">
            <h1 class="m-0 text-base font-semibold">{{ t("title") }}</h1>
            <p class="m-0 text-sm">{{ t("subtitle") }}</p>
        </div>
        <BaseButton
            as="a"
            href="/user/entreprise#subscriptions"
            :label="t('button')"
            severity="danger"
            size="small"
            class="shrink-0"
        />
    </div>
</template>
